import { memo, useContext } from 'react'
import { Handle, Position, type NodeProps } from 'reactflow'
import { LogOut } from 'lucide-react'
import { ExecutionContext } from '../../../components/flow-nodes/shared/ExecutionContext'

// Handle 样式常量
const HANDLE_STYLE_RED = {
  width: 12,
  height: 12,
  background: '#ef4444',
  border: '2px solid #dc2626',
} as const

// 自定义节点组件：出口节点
export const OutputNode = memo(({ data, selected, id }: NodeProps) => {
  const { activeNodeId, visitedNodeIds } = useContext(ExecutionContext)
  const isActive = activeNodeId === id
  const isVisited = visitedNodeIds.has(id)
  
  return (
    <div className={`px-4 py-2 shadow-md rounded-full bg-red-500 text-white border-2 border-red-600 transition-all duration-300 ${
      isActive 
        ? 'ring-4 ring-red-400/50 animate-pulse scale-105' 
        : selected 
          ? 'ring-2 ring-red-500/30 shadow-xl' 
          : isVisited 
            ? 'ring-2 ring-red-300/50' 
            : ''
    }`}>
      <Handle
        type="target"
        position={Position.Left}
        style={HANDLE_STYLE_RED}
      />
      
      <div className="flex items-center gap-2">
        <LogOut className="h-4 w-4" />
        <span className="font-medium text-sm">{data.label}</span>
      </div>
    </div>
  )
})

OutputNode.displayName = 'OutputNode'